export default __webpack_public_path__ + "static/ResetPassword-fdfdf3f90ac4d8a13594cf82c053ae23.jpg";